/** Build-Zeit-Konfiguration. Nur oeffentliche Werte – Secrets bleiben in den Functions. */

export const REQUIRED_ENV = ['VITE_IDENTITY_URL', 'VITE_IDENTITY_ANON_KEY'] as const;

export function missingEnv(): string[] {
  const env = import.meta.env as unknown as Record<string, string | undefined>;
  return REQUIRED_ENV.filter((key) => !env[key]);
}

export const HUB_ORIGIN =
  (import.meta.env.VITE_HUB_ORIGIN as string | undefined) ?? 'https://hub.smiling-data-club.de';

/**
 * Origin der People-App, die `/api/absences-today` bereitstellt.
 * Leer = keine Quelle, das Panel zeigt dann „Anbindung folgt".
 */
export const PEOPLE_API_ORIGIN = (
  (import.meta.env.VITE_PEOPLE_API_ORIGIN as string | undefined) ?? ''
).replace(/\/+$/, '');
